import {FC} from 'react';

import {DeviceModelsList} from '../../../components/Dictionaries/DeviceModels';
import {DeviceModelControl} from '../../../components/Dictionaries/DeviceModels/DeviceModelControl/index';

import styles from './DeviceModels.module.scss';

const DeviceModelsPage: FC = () => {
  return (
    <div className={styles.deviceModels}>
      <DeviceModelsList />
      <DeviceModelControl />
    </div>
  );
};

export default DeviceModelsPage;
